<!-- <div class="preview-backdrop" [ngClass]="{ 'backdrop-loading': !isLoaded && type == 'pdf' }"></div> -->
<div class="preview-stage">
  <div class="preview-header">
    <div class="info">
      <!-- <div class="user">{{item.answer_user.full_name}}</div>
            <div class="date">{{item.date | amCalendar:moment_calendar_format}}</div> -->
    </div>
  </div>

  <div
    id="doc-viewer-img"
    *ngIf="
      !['xlsx', 'xls', 'docx', 'doc', 'pdf', 'ppt', 'pptx'].includes(
        file?.ext?.toLowerCase()
      )
    "
  >
    <img [src]="file.file" ngxViewer style="max-width: 60%" />
  </div>

  <div
    id="doc-viewer"
    *ngIf="
      ['xlsx', 'xls', 'docx', 'doc', 'ppt', 'pptx'].includes(
        file?.ext?.toLowerCase()
      )
    "
  >
    <ngx-doc-viewer
      *ngIf="
        file.ext != null &&
        ['xlsx', 'xls', 'docx', 'doc', 'ppt', 'pptx'].includes(
          file?.ext?.toLowerCase()
        )
      "
      #docViewer
      [url]="file.file"
      viewer="office"
      style="max-width: 60%; width: 100%; height: 100%"
    ></ngx-doc-viewer>
  </div>

  <div id="doc-viewer-pdf" *ngIf="file?.ext?.toLowerCase() == 'pdf'">
    <pdf-viewer
      class="preview-element"
      [src]="file.file"
      [render-text]="true"
      [show-all]="false"
      [zoom]="zoom"
      [page]="page"
      (error)="onError($event)"
      (after-load-complete)="afterLoadComplete($event)"
      (on-progress)="onProgress($event)"
      style="
        display: block;
        max-width: 100%;
        margin: auto;
        width: 60%;
        height: 80%;
      "
      *ngIf="file?.ext?.toLowerCase() == 'pdf'"
    ></pdf-viewer>
  </div>

  <div
    class="file-actions-wrapper"
    style="height: 100%; position: absolute; top: 40%; right: 40px; width: 15%"
  >
    <h3>{{ file.filename }}</h3>
    <p>
      By {{ file.sent_by?.full_name }} •
      <!-- {{
        fileDetails.upload_date
          | amFromUtc
          | amLocal
          | amCalendar: moment_calendar_format
      }} -->
    </p>
    <p *ngIf="folderName">In {{ folderName }}</p>

    <div *ngIf="renamingFile" style="margin-bottom: 20px">
      <input
        #txtRenameFile
        type="text"
        class="form-control rename-file-input"
        style="text-align: center; font-weight: 700; margin-bottom: 10px"
        value="{{ file.filename.substring(0, file.filename.lastIndexOf('.')) }}"
      />
      <div class="row">
        <div class="col-sm-6">
          <button
            class="btn btn-default btn-block"
            (click)="renamingFile = false"
          >
            Cancel
          </button>
        </div>
        <div class="col-sm-6">
          <button
            class="btn btn-primary btn-block"
            (click)="renameFile(file.etag, txtRenameFile.value)"
          >
            Rename
          </button>
        </div>
      </div>
    </div>

    @if (!isQboItemPreview) {
      <button class="btn btn-light mb-2 btn-block" (click)="downloadFile()">
        <i class="feather download"></i> Download
      </button>
      <!-- <button class="btn btn-light mb-2 btn-block" (click)="printFile()">
        <i class="feather printer"></i> Print
      </button> -->
      <button
        class="btn btn-light mb-2 btn-block"
        (click)="openRenameFile()"
        *ngIf="
          !shouldDisableButton('rename') &&
          (isAccountant || checkClientForDeleteFile()) &&
          !file['from_attachment']
        "
      >
        <i class="feather edit-3"></i> Rename
      </button>
      <button
        class="btn btn-light mb-2 btn-block"
        (click)="openModalMoveFile()"
        *ngIf="!shouldDisableButton('move') && isAccountant"
      >
        <i class="feather corner-up-left"></i> Move to Folder
      </button>
      <button
        class="btn btn-default btn-block delete"
        (click)="openModalDeleteFile(deleteModal)"
        *ngIf="
          !shouldDisableButton('delete') &&
          (isAccountant || checkClientForDeleteFile()) &&
          !file['from_attachment']
        "
      >
        <i class="feather trash-2"></i>Delete
      </button>
    }

    <button
      style="margin-top: 40px"
      class="btn btn-block btn-primary"
      (click)="closeFilePreview()"
    >
      <i class="feather x"></i>Close
    </button>
  </div>
</div>

<div
  class="preview-navigation"
  *ngIf="isLoaded || file?.ext?.toLowerCase() != 'pdf'"
>
  <div
    class="preview-navigation-item"
    *ngIf="file?.ext?.toLowerCase() == 'pdf'"
  >
    <div class="label">Page</div>
    <div>
      <input class="text-right" type="text" [(ngModel)]="page" /><span
        style="opacity: 0.6"
      >
        / {{ totalPages }}&nbsp;&nbsp;</span
      >
    </div>
    <div>
      <button (click)="prevPage()" [disabled]="page === 1">
        <i class="feather chevron-up" tooltip="Previous Page"></i>
      </button>
      <button (click)="nextPage()" [disabled]="page === totalPages">
        <i class="feather chevron-down" tooltip="Next Page"></i>
      </button>
    </div>
  </div>
  <div
    class="preview-navigation-item"
    *ngIf="file?.ext?.toLowerCase() == 'pdf'"
  >
    <div class="label">Zoom</div>
    <div>
      <input
        type="text"
        disabled
        [ngModel]="zoom"
        maxlength="3"
        style="max-width: 25px"
      />
    </div>
    <div>
      <button (click)="zoomOut()" [disabled]="zoom <= 1">
        <i class="feather minus" tooltip="Zoom Out"></i>
      </button>
      <button (click)="zoomIn()" [disabled]="zoom >= 2">
        <i class="feather plus" tooltip="Zoom In"></i>
      </button>
    </div>
  </div>
</div>

<ng-template #deleteModal>
  <div class="modal-header text-center" style="border-bottom: none">
    <!-- <i class="feather check-circle x3" style="color: #0084ff;"></i> -->
    <div class="m-auto">
      <h4>Are you sure?</h4>
      <p>
        You are about to delete the file
        <strong>{{ file.filename }}</strong
        >.<br />
        If you want to proceed, click delete.
        <!-- <a routerLink="/terms-of-service" target="_blank" rel="noreferrer noopener">Terms of Service</a> and
      <a routerLink="/privacy-policy" target="_blank" rel="noreferrer noopener">Privacy Policy</a>. -->
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
    <div class="btn btn-danger pull-right" (click)="deleteFile(file.etag)">
      Delete
    </div>
  </div>
</ng-template>
